import React, { useEffect } from "react";
// import getAuthUser from "./utils/getAuthUser";
import Router from "./Router";
import { useAuth } from "./Context/authContext";
import { detectionUrls } from "./config";
import { ConfigProvider, Spin, Table, theme } from "antd";
import customTheme from "./globalTheme";
import backgroundVideo from "./images/leaks_detection_background_video.mp4";
import ToastContainerWrapper from "./lib/Toaster";
import { useNavigate } from "react-router-dom";

// const detection_app_urls = detectionUrls(process.env.REACT_APP_ENV || "dev");

let url = "https://api.dev.detection.umgapps.com/";

let authURL = "https://login.devops.umgapps.com/oauth2/detection-dev";
// eslint-disable-next-line default-case
switch (process.env.REACT_APP_ENV || "dev") {
  case "dev":
    authURL = "https://login.devops.umgapps.com/oauth2/detection-dev";
    url = "https://api.dev.detection.umgapps.com/";
    break;
  case "qa":
    authURL = "https://login.devops.umgapps.com/oauth2/detection-qa";
    url = "https://api.qa.detection.umgapps.com/";
    break;
  case "uat":
    authURL = "https://login.devops.umgapps.com/oauth2/detection-stage";
    url = "https://api.stage.detection.umgapps.com/";
    break;
  case "prod":
    authURL = "https://login.devops.umgapps.com/oauth2/detection";
    url = "https://api.detection.umgapps.com/";
    break;
  default:
    authURL = "https://login.devops.umgapps.com/oauth2/detection-dev";
    url = "https://api.dev.detection.umgapps.com/";
}

export const BASE_URL = url;
export const BASE_AUTH_URL = authURL;

function App() {
  // const user = getAuthUser();
  const { darkTheme, lightTheme } = customTheme;
  const { loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <>
        {" "}
        <div className="loading-overlay">
          <Spin
            size="default"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
              opacity: 0.8,
            }}
          />
        </div>
      </>
    );
  }

  return (
    <div className="App">
      <ConfigProvider
        //   theme={
        //     {
        //     algorithm: theme.defaultAlgorithm,
        //     token: lightTheme,
        //   },
        //       components: {
        //     Table: {
        //       // Optionally add more customizations for Table here
        //     },
        //   },
        // }
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: lightTheme,
          components: {
            Table: {
              colorBgContainer: "none",
              headerColor: "#4AB2F2",
              headerSplitColor: "transparent",
              colorSplit: "red",
              // Optionally add more customizations for Table here
            },
            Button: {
              // Apply global styles to all buttons

              paddingContentHorizontal: 20, // Horizontal padding
              paddingContentVertical: 0, // Vertical padding
            },
          },
        }}
      >
        {/* <div className="background-video-container">
          <video autoPlay muted loop className="background-video">
            <source src={backgroundVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div> */}
        <div style={{ zIndex: "1", position: "relative" }}>
          <ToastContainerWrapper />
          <Router />
        </div>
      </ConfigProvider>
    </div>
  );
}

export default App;
